import React, { useEffect, useState } from "react";
import Logo from "../../Assets/logo.png";
import { Link, useLocation } from "react-router-dom";
import NavItem from "./NavItem";
import "./Nav.css";
import { useWindowSize } from "@uidotdev/usehooks";
import Menu from "../../Assets/menu.png";

// CDR ANZSCO Code
// RPL ANZSCO Code

const Nav = () => {
  const [popped, setPopped] = useState<boolean>(false);
  const size = useWindowSize();
  const location = useLocation();
  useEffect(() => {
    setPopped(false);
  }, [location]);
  if (size.width && size.width > 1200) {
    return (
      <div className="nav">
        <div className="navCont">
          <Link className="logo" to={"/"}>
            <img src={Logo} alt="Logo" />
          </Link>
          <div>
            <NavItem
              items={[
                { name: "CDR Writing", path: "cdrwriting" },
                { name: "Career Episode Writing", path: "careerepisodewriting" },
                { name: "Stage 2 Competency Claim", path: "stage2competencyclaim" },
                { name: "CDR Reviewing Service", path: "cdrreviewingservice" },
                { name: "ACS RPL Report Writing", path: "acsrplreportwriting" },
                { name: "KA02 Report Writing", path: "ka02rportwriting" },
                { name: "Plagiarism Checking and Removal", path: "plagiarismcheckingandremoval" },
                { name: "1-to-1 Tutoring", path: "tutoring" },
                { name: "NER Services", path: "nerservices" },
                { name: "IML ANZ assessment", path: "imlanzassessment" },
              ]}
              name="Services"
            />
            <NavItem path="cdrsamples" name="CDR Samples" />
            <NavItem
              items={[
                { name: "CDR ANZSCO Code", path: "cdranzsco" },
                { name: "RPL ANZSCO Code", path: "rplanzsco" },
              ]}
              name="ANZSCO Code"
            />
            <NavItem path="pricing" name="Pricing" />
            <NavItem path="blog" name="Blog" />
            <NavItem path="faqs" name="FAQs" />
          </div>
          <a className="contact-nav-item" href={"https://api.whatsapp.com/send?phone=61488877505"}>
            Contact Us
          </a>
        </div>
      </div>
    );
  } else
    return (
      <div className="mobileNav">
        <div className="navCont">
          <div className="top">
            <Link className="logo" to={"/"}>
              <img src={Logo} alt="Logo" />
            </Link>
            <button onClick={() => setPopped(!popped)}>
              <img src={Menu} alt="Menu" />
            </button>
          </div>
          {popped && (
            <div className="items">
              <NavItem
                items={[
                  { name: "CDR Writing", path: "cdrwriting" },
                  { name: "Career Episode Writing", path: "careerepisodewriting" },
                  { name: "Stage 2 Competency Claim", path: "stage2competencyclaim" },
                  { name: "CDR Reviewing Service", path: "cdrreviewingservice" },
                  { name: "ACS RPL Report Writing", path: "acsrplreportwriting" },
                  { name: "KA02 Report Writing", path: "ka02rportwriting" },
                  { name: "Plagiarism Checking and Removal", path: "plagiarismcheckingandremoval" },
                  { name: "1-to-1 Tutoring", path: "tutoring" },
                  { name: "NER Services", path: "nerservices" },
                  { name: "IML ANZ assessment", path: "imlanzassessment" },
                ]}
                name="Services"
              />
              <NavItem path="cdrsamples" name="CDR Samples" />
              <NavItem
                items={[
                  { name: "CDR ANZSCO Code", path: "cdranzsco" },
                  { name: "RPL ANZSCO Code", path: "rplanzsco" },
                ]}
                name="ANZSCO Code"
              />
              <NavItem path="pricing" name="Pricing" />
              <NavItem path="blog" name="Blog" />
              <NavItem path="faqs" name="FAQs" />
              <a className="contact-nav-item" href={"https://api.whatsapp.com/send?phone=61488877505"}>
                Contact Us
              </a>
            </div>
          )}
        </div>
      </div>
    );
};

export default Nav;
